import { Component, OnInit, TemplateRef } from '@angular/core';
import { HomeService } from '../../services/home.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { SharedConsts } from 'src/app/shared/constants';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'offers-slider',
    templateUrl: './offers-slider.component.html',
    styleUrls: ['./offers-slider.component.scss'],
    standalone: false
})
export class OffersSliderComponent implements OnInit {
  bsModalRef: BsModalRef;
  slides = [];
  slideConfig = {
    "slidesToShow": 3,
    "slidesToScroll": 3,
    "infinite": true,
    "loop": true,
    "autoplay": {
      delay : 2000,
    },
    "pauseOnHover":false,
    "pauseOnFocus":false,
    'responsive': [
      { 'breakpoint': 1700, 'settings': {'slidesToShow': 3,"slidesToScroll": 3}},
      { 'breakpoint': 992, 'settings': {'slidesToShow': 2,"slidesToScroll": 2}},
      { 'breakpoint': 767, 'settings': {'slidesToShow': 1,"slidesToScroll": 1}},
    ]
  };
  constructor(private homeService: HomeService, private statePersist: StatePersistService,
    private router: Router, private toastService:AlertService,private modalService: BsModalService,
    private googleAnalyticsService: GoogleAnalyticsService, private statePersiste: StatePersistService,
    private alertService: AlertService) { }

  ngOnInit(): void {
    this.webPromoBanner()
    this.statePersiste.watchhomepagePromotionProductsStorage().subscribe(message => {
      this.webPromoBanner()
    })
  }

  redirectTo(obj){
    let url;
    if (obj.banner_url != ''){
      if (obj.promotion_filter != ''){
        this.statePersist.setLocalStorage('product_data', {'promotion_filter':obj.promotion_filter})
        url = 'product/listing/All'
      }
      else {
        url = 'product' + obj.banner_url.split('product')[1]
      }
      this.router.navigate([url]);
    }
    
  }

  allPromotions(){
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PROMOTIONS_VIEW_ALL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,SharedConsts.HOME_PROMOTIONS_VIEW_ALL_EVENT_ACTION , SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate(['promotion/All'])
  }

  viewPromotionsProducts(url, rule_id){
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PROMOTIONS_VIEW_ALL_PRODUCTS_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_PROMOTIONS_VIEW_ALL__PRODUCTS_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate([url+rule_id])
  }

  onChangePromotionCount(slide,event,template: TemplateRef<any>,index){
    if(event == 0){
      this.slides[index].promotion_applied_count = 0
      this.bsModalRef = this.modalService.show(template,  Object.assign({}, {class: 'modal-dialog-centered custom-modal confirm' , backdrop:  'static' as 'static', keyboard: false, initialState : slide.rule_id}));
    }
    else if(event < slide.promotion_applied_count){
      let originalCount = this.slides[index].promotion_applied_count
      this.slides[index].promotion_applied_count = this.slides[index].promotion_applied_count -1 
      this.removeDeal(slide.rule_id,false,originalCount)
    }else{
      this.addDeal(slide.rule_id)
    }
  }

  webPromoBanner(){
    this.homeService.webPromoBanner()
      .subscribe(
        data => {
          if (data.response) {
            let images_array = [];
            let images;
            images = data.response.promo_banners
            for (let i = 0; i < images.length; i++) {
              images_array.push(images[i])
            }
            this.slides = images_array
          }
        }
      );
  }

  addDeal(rule_id) {
    var dataObj = { 'rule_id': rule_id }
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PROMOTION_ADD_DEAL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_PROMOTION_ADD_DEAL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.homeService.addDeal(dataObj).subscribe({
      next: (data) => {
        if (data.status == 1180) {
          localStorage.setItem('closeStorInfoMessage', data.response.msg)
          document.getElementById("openclosedStoreInfo").click();
        }
        else if (data.status == 2212) {
          this.alertService.error(data.response)
          this.webPromoBanner()
        }
        else if (data.status == 1165) {
          this.toastService.error('Some of the products of the promotion are not available now.')
          this.webPromoBanner()
        }
        else if (data.status == 403 || data.status == 1151 || data.status == 1163) {
          this.toastService.error(data.response)
          this.webPromoBanner()
        }
        else {
          for (let i = 0; i < this.slides.length; i++) {
            if (this.slides[i]['rule_id'] == rule_id) {
              this.slides[i]['is_promotion_applied'] = 1
              this.slides[i]['promotion_applied_count'] = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0
            }
          }
          this.toastService.success('Deal Applied Sucessfully.')
          this.statePersiste.emitminiCartData('update mini cart')
        }
      }, error: (err) => {
        this.webPromoBanner()
      }
    })
  }

  removeDeal(rule_id,removefullDeal,originalCount?:any){
    let dataObj = { 'rule_id': rule_id ,removefull_deal : removefullDeal}
    this.bsModalRef?.hide()
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PROMOTION_REMOVE_DEAL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_PROMOTION_REMOVE_DEAL_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.homeService.removeDeal(dataObj).subscribe({
      next: (data) => {
        if (data.status == 1180) {
          localStorage.setItem('closeStorInfoMessage', data.response.msg)
          document.getElementById("openclosedStoreInfo").click();
        }
        if (data.status == 2212) {
          this.alertService.error(data.response)
          this.webPromoBanner()
        }
        else if (data.status == 1165) {
          this.toastService.error('Some of the products of the promotion are not available now.')
          this.webPromoBanner()
        }
        else if (data.status == 403 || data.status == 1151 || data.status == 1163) {
          this.toastService.error(data.response)
          this.webPromoBanner()
        }
        else {
          for (let i = 0; i < this.slides.length; i++) {
            if (this.slides[i]['rule_id'] == rule_id) {
              this.slides[i]['is_promotion_applied'] = data.response?.promotion_applied_count && data.response?.promotion_applied_count > 0 ? 1 : 0
              this.slides[i]['promotion_applied_count'] = data.response.promotion_applied_count ? data.response.promotion_applied_count : 0
            }
          }
          this.toastService.success('Deal Removed Successfully')
          this.statePersiste.emitminiCartData('update mini cart')
        }
      }, error: (err) => {
          this.toastService.error(err.error.message ? err.error.message : 'Something went wrong')
          let index = this.slides?.findIndex(x => x.rule_id == rule_id)
          if(index > -1){
            this.slides[index].promotion_applied_count = removefullDeal ? 1 : originalCount
          }
      }
    })
  }

  onPromotionRemovalCancel(rule_id){
    let index = this.slides?.findIndex(x => x.rule_id == rule_id)
    if(index > -1){
      this.slides[index].promotion_applied_count  = 1
    }
    this.bsModalRef?.hide()
  }
}
